const ArticleListItem = () => import('../../components/article-list-item/index.vue');

export default {
    name: 'PreparednessPage',
    
    components: {
        'list-item': ArticleListItem
    },

    computed: {
        list() {
            return this.$store.getters.getArticleList(10003);
        }
    },

    created() {
        this.$store.dispatch('fetchArticles');
        this.$store.commit('setMenuItems', this.list);
        this.$store.commit('setMenuDetails', { title: 'Preparedness', slug: 'preparedness', back_url: '/action/operations' });
    }
};